import React, { useState, useEffect, useRef, useCallback } from "react";

import { NavLink, useLocation } from 'react-router-dom';
import { API_BASE_URL } from '../../config';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import Loader2 from '../../components/loader2';
import HomeUserProfilePureCSS from "../../profiles/HomeProfilePureCSS";
import ModernNavbarPureCSS from "../../components/Navbar/ModernNavBarPureCSS";

import Swal from 'sweetalert2';
import { Formik } from "formik";
import { checkExistingQuote } from '../../components/Message/Services/checkExistingQuote';
import endpoints from '../../services/endpoints';


import { Avatar, AvatarFallback, AvatarImage } from "../../_newprofiles/components/ui/Avatar"
import { Badge } from "../../_newprofiles/components/ui/Badge"
import { Button } from "../../_newprofiles/components/ui/Button"
import { Card, CardContent, CardHeader, CardTitle } from "../../_newprofiles/components/ui/Card"

// Import styles from HomeUserJobsDashboard.module.css
import userDashboardStyles from '../JobDashboard/HomeUserJobsDashboard.module.css'; 

import Dropdown from '../../components/Dropdown/Dropdown'; 
import { NavLink as RouterNavLink } from 'react-router-dom'; 
import { User as UserIcon } from "lucide-react";



import {
  Clock,
  DollarSign,
  MapPin,
  User,
  MessageSquare,
  ArrowLeft,
} from "lucide-react"

import { Input } from "../../_newprofiles/components/ui/Input"
import { Separator } from "../../_newprofiles/components/ui/Separator"
import { Textarea } from "../../_newprofiles/components/ui/Textarea"
import Modal from '../../components/Modal/Modal';
import styles from "./JobsDesign.module.css"
import jobstyles from "../JobDashboard/NewHomeUserJobsDashboard.module.css"
import businessDashboardStyles from "../Dashboards/_BusinessDashboard.module.css";
import customSelectStyles from "./BusinessJobsDashboardPureCSS.module.css";
import quoteModalStyles from "./QuoteModal.module.css";
import api from '../../api/api.js';


// --- NEW HELPER COMPONENT FOR FORMIK EFFECT ---
// This component's sole purpose is to house the useEffect hook.
// It receives Formik's state and functions as props.
const QuoteFormEffect = ({ values, setFieldValue, quotesTemplate, selectedJob, currentUser }) => {
    React.useEffect(() => {
        // Only run if a template is selected AND we have the current user's data
        if (values.templateId && currentUser) {
            const selectedTemplate = quotesTemplate.find(t => t.id.toString() === values.templateId);
            if (selectedTemplate) {
                let message = selectedTemplate.templateMessage;
                
                const replacements = {
                    '\\[Client Name\\]': `${selectedJob?.homeUserFirstName || ''} ${selectedJob?.homeUserLastName || ''}`.trim(),
                    '\\[address\\]': selectedJob?.postcode || '',
                    '\\[phone\\]': currentUser?.phone || '',
                    '\\[Business Name\\]': currentUser?.businessName || '',
                    '\\[Your Name\\]': currentUser?.name || '',
                    '\\[ABN\\]': currentUser?.abn || '',
                };

                for (const placeholder in replacements) {
                    message = message.replace(new RegExp(placeholder, 'g'), replacements[placeholder]);
                }

                const quoteValue = values.price ? `$${values.price}` : '[quote]';
                message = message.replace(/\[quote\]/g, quoteValue);

                // `false` prevents re-validation on every price change for a smoother UX
                setFieldValue('message', message, false);
            }
        }
    }, [values.price, values.templateId, selectedJob, currentUser, quotesTemplate, setFieldValue]);

    // This component doesn't render anything itself
    return null;
};



const BusinessJobsDashboardPureCSS = () => {
  const location = useLocation();
  const jobCardRefs = useRef({});
  const [jobs, setJobs] = useState([]);
  const [filteredJobs, setFilteredJobs] = useState([]);
  const [selectedJob, setSelectedJob] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [businessUserId, setBusinessUserId] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: 'created_at', direction: 'descending' });
  // New state for status filter
  const [statusFilter, setStatusFilter] = useState("default"); 
  const [locationFilter, setLocationFilter] = useState(null);
  const [categoryFilter, setCategoryFilter] = useState(null);
  const [budgetFilter, setBudgetFilter] = useState(null);
  const [username, setUsername] = useState('');
  const [isQuoteSent, setIsQuoteSent] = useState(false);
  const [isSendQuotePopup, setIsSendQuotePopup] = useState(false);
  const [quotesTemplate, setQuoteTemplate] = useState([]);
  const [templateMessage, setTemplateMessage] = useState("");
  const [isLoadingSuccess, setIsLoadingSuccess] = useState(false);
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [jobImages, setJobImages] = useState([]);
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [isJobDetailsVisible, setIsJobDetailsVisible] = useState(false);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);
  const [currentUser, setCurrentUser] = useState(null);

  const handleResize = useCallback(() => {
    setIsMobileView(window.innerWidth <= 768);
  }, []);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [handleResize]);

  const openImageModal = (images, index) => {
    setJobImages(images.filter(img => img)); // Filter out null images
    setSelectedImageIndex(index);
    setIsImageModalOpen(true);
  };

  const closeImageModal = () => {
    setIsImageModalOpen(false);
  };

  const nextImage = () => {
    setSelectedImageIndex((prevIndex) => (prevIndex + 1) % jobImages.length);
  };

  const prevImage = () => {
    setSelectedImageIndex((prevIndex) => (prevIndex - 1 + jobImages.length) % jobImages.length);
  };

  const handleOpenProfile = (userId) => {
    setSelectedUserId(userId);
    setIsProfileOpen(true);
  };

  const handleCloseProfile = () => {
    setIsProfileOpen(false);
    setSelectedUserId(null);
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      const decodeToken = jwtDecode(token);
      const businessId = decodeToken.BusinessId;
      setBusinessUserId(businessId);

      console.log("Decoded Token:", decodeToken);
      setUsername(decodeToken.UserName || 'User');

      fetchJobs(businessId);
      getAllQuoteTemplate();
      fetchBusinessProfile(businessId);
    }
  }, []);



  const fetchBusinessProfile = async (businessId) => {
      try {
          // The API endpoint you provided. It's using the function's `businessId` parameter.
          const response = await api.get(`/api/BusinessProfile/getBusinessProfile?businessId=${businessId}&logView=false&ommitProfilePic=true`);
          
          const apiData = response.data;

          // --- NEW: Data Transformation Logic ---
          // We create a simple, flat object to use in our component.

          // 1. Find the primary location from the locations array
          const primaryLocation = apiData.locations?.find(loc => loc.isPrimary === true) || apiData.locations?.[0];

          // 2. Determine the best phone number (prioritize mobile, fallback to landline)
          let contactPhone = '';
          if (primaryLocation) {
              contactPhone = primaryLocation.mobile || primaryLocation.landline || '';
          }

          // 3. Create the clean profile object
          const profileData = {
              // As the API doesn't provide a user's name, we use the businessName as a fallback.
              name: apiData.businesses?.businessUserName || apiData.businesses?.businessName || '', 
              businessName: apiData.businesses?.businessName || '',
              phone: contactPhone,
              abn: apiData.businesses?.abn || '',
          };

          // 4. Set the clean, simplified object into state.
          setCurrentUser(profileData);

      } catch (error) {
          console.error("Failed to fetch business profile:", error);
          // The fallback object remains a good safety measure.
          setCurrentUser({ name: 'Your Name', businessName: 'Your Business', phone: 'Your Phone', abn: 'Your ABN' });
      }
  };



  useEffect(() => {
    if (location.state?.selectedJob && jobs.length > 0) {
      const jobToSelect = jobs.find(j => j.job_id === location.state.selectedJob.job_id);
      if (jobToSelect) {
        handleJobClick(jobToSelect);
        const ref = jobCardRefs.current[jobToSelect.job_id];
        if (ref) {
          ref.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    }
  }, [location.state, jobs]);

  const fetchJobs = async (businessId) => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axios.get(`${API_BASE_URL}/api/Jobs/getMyJobsForBusiness?businessId=${businessId}`);
      if (response.data !== 'Subscription Expired !!') {
        const fetchedJobs = response.data;
        setJobs(fetchedJobs);
        setFilteredJobs(fetchedJobs);
        if (location.state?.selectedJob) {
          const jobToSelect = fetchedJobs.find(j => j.job_id === location.state.selectedJob.job_id);
          if (jobToSelect) {
            setSelectedJob(jobToSelect);
            handleJobClick(jobToSelect);
          } else if (fetchedJobs.length > 0) {
            setSelectedJob(fetchedJobs[0]);
          }
        } else if (fetchedJobs.length > 0) {
          setSelectedJob(fetchedJobs[0]);
        }
      } else {
        setJobs([]);
        setFilteredJobs([]);
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };


    const handleMessageClient = async (e, selectedJob) => {
        //setLoading(true);
        try {
    
            // The 'null, 2' part makes the JSON output nicely indented and readable
            //console.log(JSON.stringify(selectedJob, null, 2));

            console.log(`clientUser.homeUserId = ${selectedJob.userId}`);
    
            const token = localStorage.getItem('token');
            const { nameid: currentUserId, UserType } = jwtDecode(token);

            const myuserType = localStorage.getItem('userType');
            const loggedInBusinessUserId = localStorage.getItem('loggedInBusinessUserId');

            let url = "";


            // Logged in Business            
            const senderBusinessUserId = loggedInBusinessUserId;
    
            // Client receiving this message
            const homeUserId = selectedJob.userId;
    
            // Debugging
            console.log(`senderBusinessUserId = ${senderBusinessUserId}`);
            console.log(`homeUserId = ${homeUserId}`);
    
            // This is conversation is always between the current businessUserId and a client home user
            url = `senderBusinessUserId=${senderBusinessUserId}&homeUserId=${homeUserId}`;

            const { data } = await axios.get(
            `${API_BASE_URL}/api/Chat/NewConversation?${url}`
            );
    
            // 4. Pull out the conversationId and open the right route in a new tab
            const { conversationId } = data;
            const path = `/business_messages?conversationId=${conversationId}`;
    
            window.open(path, '_blank', 'noopener,noreferrer');

        } catch (err) {
            console.error('Error starting conversation:', err);
        } finally {
            //setLoading(false);
        }
        };


  const handleJobClick = async (job) => {
    setSelectedJob(job);
    setIsJobDetailsVisible(true); // Always show details on click
    if (job) {
      const response = await checkExistingQuote(job.job_id, businessUserId);
      setIsQuoteSent(response);
    }
  };

  const handleBackToList = () => {
    setIsJobDetailsVisible(false);
  };

  const getAllQuoteTemplate = async () => {
      try {
          const response = await api.get(`/${endpoints.getQuoteTemplate}`);
          console.log(response);
          setQuoteTemplate(response.data);
      } catch (error) {
          setError(error.message);
      }
  };

  const OnOpenSendQuote = () => {
      setIsSendQuotePopup(true);
  }

  const OnClosePopup = () => {
      setIsSendQuotePopup(false);
  }

  const SendQuote = async (values) => {
      setIsLoading(true);
      setIsLoadingSuccess(false);

      const loggedInBusinessId = localStorage.getItem('loggedInBusinessId');
      const loggedInBusinessUserId = localStorage.getItem('loggedInBusinessUserId');

      console.log(`loggedInBusinessId = ${loggedInBusinessId}`);
      console.log(`loggedInBusinessUserId = ${loggedInBusinessUserId}`);

      let params = {
          jobId: selectedJob.job_id,
          businessUserId: loggedInBusinessUserId,
          businessId: loggedInBusinessId,
          homeUserId: selectedJob.userId,
          price: values?.price,
          message: values?.message,
          templateId: values?.templateId || 0

      }

      console.log(params);

      try {
          const response = await axios.post(`${API_BASE_URL}/${endpoints.sendQuote}${selectedJob.job_id}/quote`, params);

          setTimeout(() => {
              setIsLoading(false);
              setIsLoadingSuccess(true);
              Swal.fire({
                  icon: 'success',
                  title: 'Quote Sent !!',
                  text: null,
                  timer: 1500,
                  showConfirmButton: false,
                  customClass: "confirmation-popup"
              }).then(() => {
                  setIsSendQuotePopup(false);
                  // Maybe refresh jobs or just update the button state
                  setIsQuoteSent(true);
              });

          }, 500);
      } catch (error) {
          setIsLoading(false);
          setIsLoadingSuccess(false);
          setError(error.message);
          console.log(error.response.data); 
      } finally {
          setIsLoading(false);
          setIsLoadingSuccess(false);
      }
  }



  const handleSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  // Function to get sort indicator
  const getSortIndicator = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === 'ascending' ? ' ▲' : ' ▼';
    }
    return '';
  };

  useEffect(() => {
    let itemsToFilter = [...jobs];

    // Apply status filter
    if (statusFilter === "default") {
      itemsToFilter = itemsToFilter.filter(job => job.jobStatus !== "Archived");
    } else if (statusFilter === "Open") {
      itemsToFilter = itemsToFilter.filter(job => job.jobStatus === "Open");
    } else if (statusFilter === "Completed") {
      itemsToFilter = itemsToFilter.filter(job => job.jobStatus === "Completed");
    } else if (statusFilter === "Pending") {
      itemsToFilter = itemsToFilter.filter(job => job.jobStatus === "Pending");
    }
    // "All" filter means no status filtering, which is handled by not adding a filter condition here.

    // Apply search term filter
    if (searchTerm) {
        const lowercasedSearchTerm = searchTerm.toLowerCase();
        itemsToFilter = itemsToFilter.filter(job =>
            (job.name && job.name.toLowerCase().includes(lowercasedSearchTerm)) ||
            (job.description && job.description.toLowerCase().includes(lowercasedSearchTerm)) ||
            (job.postcode && job.postcode.toLowerCase().includes(lowercasedSearchTerm)) ||
            (job.created_at && new Date(job.created_at).toLocaleDateString().toLowerCase().includes(lowercasedSearchTerm))
        );
    }

    // Apply sorting
    if (sortConfig.key !== null) {
        itemsToFilter.sort((a, b) => {
            let valA = a[sortConfig.key];
            let valB = b[sortConfig.key];

            if (sortConfig.key === 'created_at') {
                valA = new Date(a.created_at);
                valB = new Date(b.created_at);
            } else if (sortConfig.key === 'budgetAmount') {
                valA = Number(a.budgetAmount) || 0;
                valB = Number(b.budgetAmount) || 0;
            } else if (sortConfig.key === 'category') { // Assuming 'category' maps to profession name
                valA = a.profession && a.profession.length > 0 ? a.profession[0].name.toLowerCase() : '';
                valB = b.profession && b.profession.length > 0 ? b.profession[0].name.toLowerCase() : '';
            }

            if (valA < valB) {
                return sortConfig.direction === 'ascending' ? -1 : 1;
            }
            if (valA > valB) {
                return sortConfig.direction === 'ascending' ? 1 : -1;
            }
            return 0;
        });
    }
    setFilteredJobs(itemsToFilter);

    // Logic to keep selectedJob consistent after filtering/sorting
    if (location.state?.selectedJob) {
        const jobFromState = itemsToFilter.find(j => j.job_id === location.state.selectedJob.job_id);
        if (jobFromState) {
            // Do not set selected job here, let the other useEffect handle it
            return;
        }
    }
    
    if (selectedJob && !itemsToFilter.some(job => job.job_id === selectedJob.job_id)) {
      if (itemsToFilter.length > 0) {
        setSelectedJob(itemsToFilter[0]);
      } else {
        setSelectedJob(null);
      }
    } else if (!selectedJob && itemsToFilter.length > 0) {
      setSelectedJob(itemsToFilter[0]);
    }
  }, [jobs, searchTerm, sortConfig, statusFilter, location.state]); // Added statusFilter to dependencies

  const stats = {
    newJobLeads: jobs.length,
    quotesSent: 25, //dummy data
    acceptanceRate: "60%", //dummy data
    activeJobs: 5, //dummy data
    totalEarnings: "$50,000" //dummy data
  };

  return (
    <>
      
      <div className={jobstyles.jobDashboard_minHeightScreen + ' ' + jobstyles.jobDashboard_bgGradientBlueAmber}>

        <ModernNavbarPureCSS UserName={username} prefix={''} TabActiveId={'jobs'} />

        {/* Header */}
        <header className={jobstyles.jobDashboard_bgGradientHeader + ' ' + jobstyles.jobDashboard_header} style={{ position: 'sticky', top: 0, zIndex: 1020 }}>
          <div className={jobstyles.jobDashboard_container}>
            <div className={jobstyles.bizjobDashboard_headerContent}>
              <div className={jobstyles.jobDashboard_headerLeft}>
                <div className={jobstyles.jobDashboard_headerLogo}>
                  <h1 className={jobstyles.jobDashboard_text2xl + ' ' + jobstyles.jobDashboard_fontBold}>Job Leads Dashboard</h1>
                </div>
              </div>

              
            </div>
          </div>
        </header>

        <div className={jobstyles.jobDashboard_container + ' ' + jobstyles.jobDashboard_py8}>

              {/* search and filter with the one from HomeUserJobsDashboard */}
              <div className={userDashboardStyles.jobDashboard_card + ' ' + userDashboardStyles.jobDashboard_mb8}>
                <div className={userDashboardStyles.jobDashboard_cardContent}>
                  <div className={userDashboardStyles.jobDashboard_searchFilterContainer}>
                    <div className={userDashboardStyles.jobDashboard_searchInputContainer}>
                      <span className={userDashboardStyles.jobDashboard_searchInputIcon + ' ' + userDashboardStyles.jobDashboard_textGray400}>🔍</span>
                      <input
                        type="text"
                        placeholder="Search by name, description, category..."
                        className={userDashboardStyles.jobDashboard_input + ' ' + userDashboardStyles.jobDashboard_searchInputMain}
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)} />
                    </div>
                    <div className={userDashboardStyles.jobDashboard_filterButtons}>
                      <Dropdown
                        placeholder="Filter by Status"
                        options={[
                          { value: "default", label: "Default (No Archived)" },
                          { value: "All", label: "Show All Jobs" },
                          { value: "Open", label: "Show Open Jobs" },
                          { value: "Completed", label: "Show Completed Jobs" },
                          { value: "Pending", label: "Show Pending Jobs" },
                        ]}
                        onSelect={setStatusFilter}
                        styles={userDashboardStyles.Dropdown}
                      />
                      <button className={userDashboardStyles.jobDashboard_btn + ' ' + userDashboardStyles.jobDashboard_btnOutline + ' ' + userDashboardStyles.jobDashboard_btnSm} onClick={() => handleSort('created_at')}>
                        <span className={userDashboardStyles.jobDashboard_h4 + ' ' + userDashboardStyles.jobDashboard_w4 + ' ' + userDashboardStyles.jobDashboard_mr2}>📅</span>
                        Sort by Date{getSortIndicator('created_at')}
                      </button>
                      <button className={userDashboardStyles.jobDashboard_btn + ' ' + userDashboardStyles.jobDashboard_btnOutline + ' ' + userDashboardStyles.jobDashboard_btnSm} onClick={() => handleSort('budgetAmount')}>
                        <span className={userDashboardStyles.jobDashboard_h4 + ' ' + userDashboardStyles.jobDashboard_w4 + ' ' + userDashboardStyles.jobDashboard_mr2}>💰</span>
                        Sort by Budget{getSortIndicator('budgetAmount')}
                      </button>
                      <button className={userDashboardStyles.jobDashboard_btn + ' ' + userDashboardStyles.jobDashboard_btnOutline + ' ' + userDashboardStyles.jobDashboard_btnSm} onClick={() => handleSort('category')}>
                        <span className={userDashboardStyles.jobDashboard_h4 + ' ' + userDashboardStyles.jobDashboard_w4 + ' ' + userDashboardStyles.jobDashboard_mr2}>🏷️</span>
                        Sort by Category{getSortIndicator('category')}
                      </button>
                    </div>
                  </div>
                </div>
              </div>



            {/* Jobs Layout */}
            <div className={`${styles.jobsLayout} ${isJobDetailsVisible ? styles.detailsVisible : ''}`}>
                {/* Jobs List */}
                <div className={styles.jobsList}>
                    {isLoading && <Loader2 />}
                    {!isLoading && error && <p>Error: {error}</p>}
                    {!isLoading && !error && filteredJobs.map((job) => (
                        <Card
                            key={job.job_id}
                            ref={el => jobCardRefs.current[job.job_id] = el}
                            className={`${styles.jobCard} ${selectedJob && selectedJob.job_id === job.job_id ? styles.jobCardSelected : ""}`}
                            onClick={() => handleJobClick(job)}
                        >
                            <CardContent className={styles.jobCardContent}>
                                <div className={styles.jobCardGrid}>
                                    <div className={styles.jobCardMain}>
                                        <div className={styles.jobTitleContainer}>
                                            <h3 className={styles.jobTitle}>{job.name}</h3>
                                            {job.deadline === "Urgently" && (
                                                <Badge variant="destructive" className={styles.urgentBadge}>
                                                    Urgent
                                                </Badge>
                                            )}
                                        </div>
                                        <div className={styles.jobMeta}>
                                            <div className={styles.jobMetaItem}>
                                                <User className="h-4 w-4" />
                                                <span>{`${job.homeUserFirstName} ${job.homeUserLastName}`}</span>
                                            </div>
                                            <div className={styles.jobMetaItem}>
                                                <MapPin className="h-4 w-4" />
                                                <span>{job.postcode}</span>
                                            </div>
                                            <div className={styles.jobMetaItem}>
                                                <Clock className="h-4 w-4" />
                                                <span>{new Date(job.created_at).toLocaleDateString()}</span>
                                            </div>
                                        </div>
                                        <p className={styles.jobDescription}>{job.description}</p>

                    {job.assignedBusinessId == businessUserId && (
                        <div className={styles.assignedBadge}>
                            <User className={styles.assignedBadgeIcon} size={14} />
                            <span>Assigned to you</span>
                        </div>
                    )}

                                    </div>
                                    <div className={styles.jobCardAside}>
                                        <div className={styles.jobBudget}>
                                            <DollarSign className="h-4 w-4" />
                                            <span>{job.budgetAmount ? `$${job.budgetAmount}` : job.budget}</span>
                                        </div>
                                        <div className={styles.jobStats}>
                                            <div className={styles.jobStatItem}>
                                                <MessageSquare className="h-4 w-4" />
                                                <span>{job.quoteCount || 0} Quotes</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </CardContent>
                        </Card>
                    ))}
                </div>

                {/* Job Details Panel */}
                <div className={styles.jobDetailsPanel}>
                    {selectedJob && (
                        <Card className={styles.detailsCard}>
                            <CardHeader className={styles.detailsCardHeader}>
                                <CardTitle className={styles.detailsCardTitle}>
                                    {isMobileView && ( // Only show back button on mobile
                                        <button className={styles.backButton} onClick={handleBackToList}>
                                            <ArrowLeft size={24} />
                                        </button>
                                    )}
                                    <span>Job Details</span>
                                    <div className={styles.headerActions}>
                                        {!isQuoteSent ? (
                                            <Button className={styles.quoteJobButton} onClick={OnOpenSendQuote}>Quote Job</Button>
                                        ) : (
                                            <Button className={styles.quoteJobButton} disabled>Already Quoted</Button>
                                        )}

                                            <Button className={styles.quoteJobButton} onClick={(e) => handleMessageClient(e, selectedJob)} >Message Client</Button>
                                              

                                    </div>
                                </CardTitle>
                            </CardHeader>
                            <CardContent className={styles.detailsCardContent}>
                                <div className={styles.detailsContent}>
                                <div className={styles.detailsSection}>
                                    <h3 className={styles.detailsTitle}>{selectedJob.name}</h3>
                                    <p className={styles.detailsDescription}>{selectedJob.description}</p>
                                </div>
                                    <Separator />
                                    <div className={styles.detailsGrid}>

                                        <div className={styles.detailItem}>
                                            <h4 className={styles.detailLabel}>Client</h4>
                                            <p className={styles.detailValue}>
                                                <button onClick={() => handleOpenProfile(selectedJob.userId)} className={styles.clientNameLink}>
                                                    {`${selectedJob.homeUserFirstName} ${selectedJob.homeUserLastName}`}
                                                </button>
                                            </p>
                                        </div>
                                        <div className={styles.detailItem}>
                                            <h4 className={styles.detailLabel}>Location</h4>
                                            <p className={styles.detailValue}>{selectedJob.postcode}</p>
                                        </div>



                                        <div className={styles.detailItem}>
                                            <h4 className={styles.detailLabel}>Budget</h4>
                                            <p className={`${styles.detailValue} ${styles.detailValueBudget}`}>{selectedJob.budgetAmount ? `$${selectedJob.budgetAmount}` : selectedJob.budget}</p>
                                        </div>

                                        <div className={styles.detailItem}>
                                            <h4 className={styles.detailLabel}>Deadline</h4>
                                            <p className={styles.detailValue}>{selectedJob.deadline}</p>
                                        </div>
                                        <div className={styles.detailItem}>
                                            <h4 className={styles.detailLabel}>Site Visit</h4>
                                            <p className={styles.detailValue}>{selectedJob.siteVisit}</p>
                                        </div>
                                    </div>
                                    <Separator />
                                    {(selectedJob.image1 || selectedJob.image2 || selectedJob.image3 || selectedJob.image4) && (
                                        <>
                                            <div className={styles.detailsSection}>
                                                <h4 className={styles.detailLabel}>Project Images</h4>
                                                <div className={styles.projectImagesGrid}>
                                                    {[selectedJob.image1, selectedJob.image2, selectedJob.image3, selectedJob.image4].map((image, index) => (
                                                        image && <img key={index} src={image} alt={`Project image ${index + 1}`} className={styles.projectImage} onClick={() => openImageModal([selectedJob.image1, selectedJob.image2, selectedJob.image3, selectedJob.image4], index)} />
                                                    ))}
                                                </div>
                                            </div>
                                            <Separator />
                                        </>
                                    )}
                                </div>
                            </CardContent>
                        </Card>
                    )}
                </div>
            </div>
        </div>




       {/* --- MODIFIED: The Quote Popup now uses the helper component --- */}
        {isSendQuotePopup && selectedJob && (
            <Modal isOpen={isSendQuotePopup} onClose={OnClosePopup}>
                <div className="py-4">
                    <h2 className="text-lg font-bold">Send Quote</h2>
                    <p className='fs-4'>{selectedJob?.name}</p>
                    <p>{selectedJob?.postcode}</p>
                    <p>&nbsp;</p>
                    
                    <Formik
                        initialValues={{ price: '', message: '', templateId: '' }}
                        onSubmit={SendQuote}
                        validate={(values) => {
                            const errors = {};
                            if (!values.price) errors.price = "Price is required";
                            if (!values.message) errors.message = "Message is required";
                            return errors;
                        }}
                    >
                        {({ handleSubmit, handleChange, setFieldValue, values, errors, touched }) => (
                            <form onSubmit={handleSubmit} className={quoteModalStyles.form}>
                                {/* This component now handles the side effect */}
                                <QuoteFormEffect 
                                    values={values}
                                    setFieldValue={setFieldValue}
                                    quotesTemplate={quotesTemplate}
                                    selectedJob={selectedJob}
                                    currentUser={currentUser}
                                />
                                <div>
                                    <label htmlFor="price">Quote</label>
                                    <Input id="price" name="price" type="number" placeholder="Enter quote amount" value={values.price} onChange={handleChange} />
                                    {touched.price && errors.price && <p className={quoteModalStyles.error}>{errors.price}</p>}
                                </div>

                                <div>
                                    <label htmlFor="templateId">Use Template</label>
                                    <select
                                        id="templateId"
                                        name="templateId"
                                        value={values.templateId}
                                        onChange={(event) => {
                                            const templateId = event.target.value;
                                            handleChange(event); // Update Formik's state for templateId
                                            if (!templateId) {
                                                setFieldValue("message", ""); // Clear message if "Select Template" is chosen
                                            }
                                        }}
                                    >
                                        <option value="">Select Template</option>
                                        {quotesTemplate.map((data) => (
                                            <option key={data.id} value={data.id}>{data.templateName}</option>
                                        ))}
                                    </select>
                                </div>


                                <div>
                                    <label htmlFor="message">Message</label>
                                    <Textarea id="message" name="message" value={values.message} onChange={handleChange} placeholder="Message..." rows={12} />
                                    {touched.message && errors.message && <p className={quoteModalStyles.error}>{errors.message}</p>}
                                </div>
                                <div className={quoteModalStyles.actions}>
                                    <Button type="submit" isLoading={isLoading} isLoadingSuccess={isLoadingSuccess}>Send Quote</Button>
                                </div>
                            </form>
                        )}
                    </Formik>
                </div>
            </Modal>
        )}        

        {isImageModalOpen && (
            <div className={customSelectStyles.imageModalOverlay} onClick={closeImageModal}>
                <div className={customSelectStyles.imageModalContent} onClick={(e) => e.stopPropagation()}>
                    <button className={customSelectStyles.closeButton} onClick={closeImageModal}>&times;</button>
                    <button className={customSelectStyles.prevButton} onClick={prevImage}>&#10094;</button>
                    <img src={jobImages[selectedImageIndex]} alt="Enlarged project" className={customSelectStyles.enlargedImage} />
                    <button className={customSelectStyles.nextButton} onClick={nextImage}>&#10095;</button>
                </div>
            </div>
        )}
      </div>
      <HomeUserProfilePureCSS 
        isOpen={isProfileOpen} 
        onClose={handleCloseProfile} 
        userId={selectedUserId} 
      />
    </>
  
  );

};



export default BusinessJobsDashboardPureCSS;
